import { Link } from 'react-router';

import { cn } from '@shared/utils/cn';

type Props = {
  className?: string;
  href?: string;
};

/** Project logo. The seasonal decoration (`.logo-season::after`) is defined in `tailwind.css`. */
export const Logo = ({ className, href = '/' }: Props) => (
  <Link
    aria-label="Logo"
    className={cn('logo-season relative inline-flex h-10 shrink-0 align-middle', className)}
    data-slot="logo"
    to={href}
  >
    <img alt="Logo" className="size-full object-contain" src="/logo/logo.png" />
  </Link>
);
